export default "__VITE_ASSET__BbawwV_B__"